/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendMonitoringStandardProductDto } from '../../models/backend-monitoring-standard-product-dto';

export interface MonitoringScenariosProductsList$Params {
  scenario_id: number;
}

export function monitoringScenariosProductsList(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringScenariosProductsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendMonitoringStandardProductDto>>> {
  const rb = new RequestBuilder(rootUrl, monitoringScenariosProductsList.PATH, 'get');
  if (params) {
    rb.path('scenario_id', params.scenario_id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendMonitoringStandardProductDto>>;
    }),
  );
}

monitoringScenariosProductsList.PATH = '/api/monitoring/scenarios/{scenario_id}/products/';
